module.exports = __webpack_public_path__ + "static/img/pink.4c452ca6.png";